import actionTypes from '../../utilities/actionTypes';

// Action Definition

export interface IFetchFeedSuccess {
  type: actionTypes.FETCH_FEEDS_SUCCESS;
  payload: any;
}
export interface IFetchFeeds {
  type: actionTypes.FETCH_FEEDS;
}

export interface IFetchFeedPending {
  type: actionTypes.FETCH_FEEDS_PENDING;
}

export const fetchFeedsPending = (): IFetchFeedPending => {
  return { type: actionTypes.FETCH_FEEDS_PENDING };
};

export const fetchFeedsSuccess = (payload: any): IFetchFeedSuccess => {
  return {
    type: actionTypes.FETCH_FEEDS_SUCCESS,
    payload
  };
};

export const fetchFeeds = (): IFetchFeeds => {
  return {
    type: actionTypes.FETCH_FEEDS
  };
};

export type IFeedAction = IFetchFeeds | IFetchFeedSuccess | IFetchFeedPending;
